import React, { Component, useRef } from "react";
import { Droppable } from "react-beautiful-dnd";
import ColumnItem from "./ColumnItem";
import NewColumnItem from "./NewColumnItem";
import { getBoundingClientRect } from '../../../utils/functions';

class ColumnBody extends Component {
    constructor(props) {
        super(props);
        this.setPositionDiv = React.createRef();
    }

    render() {
        const { columnList, columnid, addNewItem } = this.props;

        return (
            <>
                <div style={{ position: "fixed", top: "0", left: "0" }} ref={this.setPositionDiv}></div>

                <Droppable droppableId={`${columnid}`} type="task">
                    {(provided, snapshot) => {

                        // console.log('provided', provided, snapshot)
                        if (snapshot.isDragging) {
                            if (!provided.draggableProps) {
                                provided.draggableProps = { style: {} }
                            }
                            let bound = getBoundingClientRect(this.setPositionDiv.current)
                            const offset = { x: bound.left, y: bound.top }
                            // console.log(offset.x, offset.y)
                            const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                            const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                            // console.log("y:", y, "x:", x)
                            provided.draggableProps.style.left = x;
                            provided.draggableProps.style.top = y;
                            // provided.draggableProps.style.background = 'red';

                        }
                        return (
                            <div className="column-list" ref={provided.innerRef} {...provided.droppableProps}>
                                {columnList.map((item, index) => {
                                    const { itemId, taskName, form,data } = item;
                                    // console.log('formis=====',item)
                                    return (
                                        <ColumnItem actions={this.props.actions} data={item.data} page={this.props.page} view={this.props.view} dataRow={data} removeNewSubColumn={()=>this.props.removeNewSubColumn(itemId)} itemId={itemId} key={itemId} taskName={taskName} index={index} headersData={data} headers={this.props.headers} functionsHandler={this.props.functionsHandler} />
                                    );
                                })}
                                {provided.placeholder}
                                <NewColumnItem width={this.props.width} headers={this.props.headers} column={this.props.column}  addNewItem={addNewItem} columnid={columnid} functionsHandler={this.props.functionsHandler} />

                            </div>
                        )
                    }}
                </Droppable>
            </>
        );
    }
}

export default ColumnBody;


// import React, { useRef, useState } from "react";
// import { Droppable } from "react-beautiful-dnd";
// import ColumnItem from "./ColumnItem";
// import NewColumnItem from "./NewColumnItem";
// import { getBoundingClientRect } from '../../../utils/functions';

// const ColumnBody = ({ columnList, columnid, addNewItem, newTask, setNewTask }) => {
//     const setPositionDiv = useRef();
    
//     return (
//         <>
//             <div style={{ position: "fixed", top: "0", left: "0" }} ref={setPositionDiv}></div>

//             <Droppable droppableId={`${columnid}`} type="task">
//                 {/* {(provided) => ( */}
//                 {(provided, snapshot) => {

//                     console.log('provided', provided, snapshot)
//                     if (snapshot.isDragging) {
//                         if (!provided.draggableProps) {
//                             provided.draggableProps = { style: {} }
//                         }
//                         let bound = getBoundingClientRect(setPositionDiv.current)
//                         const offset = { x: bound.left, y: bound.top }
//                         console.log(offset.x, offset.y)
//                         const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
//                         const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
//                         console.log("y:", y, "x:", x)
//                         provided.draggableProps.style.left = x;
//                         provided.draggableProps.style.top = y;

//                     }
//                     return ( 
//                         <div className="column-list" ref={provided.innerRef} {...provided.droppableProps} >
//                             {columnList.map((item, index) => {
//                                 // console.log(item);
//                                 const { itemId, itemName } = item;
//                                 return (<ColumnItem itemId={itemId} key={itemId} itemName={itemName} index={index} />
//                                 );
//                             })}
//                             {provided.placeholder}
//                             <NewColumnItem setNewTask={setNewTask} newTask={newTask} addNewItem={addNewItem} columnid={columnid} />
                            
//                         </div>
//                     )
//                 }}
//             </Droppable></>
//     );
// };

// export default ColumnBody;
